import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import { USE_CASES_NTH_USER_ONBOARDING } from '../../constants/onboarding-state/onboarding-constants';

import { getOnboardingStateGQL } from './OnboardingStatus.graphql';

export const preloadUseCasesNthUserOnboardingState = () => {
	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: getOnboardingStateGQL,
		variables: {
			key: [
				// For the banner and cards
				USE_CASES_NTH_USER_ONBOARDING.SELECTED_TEMPLATES,
				USE_CASES_NTH_USER_ONBOARDING.VIEWED_AT,
				USE_CASES_NTH_USER_ONBOARDING.DISMISSED_HEADER,
				USE_CASES_NTH_USER_ONBOARDING.VIEWED_HEADER,
			],
		},
	});
};
